import LinkElement from '../../base/link-element.js';
import css_248z from './sgds-mainnav-item2.js';

/**
 * @slot default - slot for SgdsMainnavItem element.
 *
 * @cssproperty --mainnav-item-theme-color - Hover and active color for mainnav items.
 * @cssproperty --mainnav-item-color - Text color of nav item.
 * @cssproperty --mainnav-item-borderBottom-width - border bottom width for hover and active state for nav item
 */
class SgdsMainnavItem extends LinkElement {
}
SgdsMainnavItem.styles = [LinkElement.styles, css_248z];

export { SgdsMainnavItem, SgdsMainnavItem as default };
//# sourceMappingURL=sgds-mainnav-item.js.map
